import "./ErrorState.scss";

import cx from "classnames";
import { memo } from "react";

type ErrorStateProps = {
  className?: string;
  showLogo?: boolean;
  description?: string;
};

const ErrorState = memo(
  ({
    className,
    showLogo = true,
    description = "Something went wrong. Please refresh the page and try again.",
  }: ErrorStateProps) => {
    return (
      <div className={cx("error-state", className)}>
        {showLogo && (
          <div className="error-state__logo">
            <img
              className="logo-img"
              src="/static/images/logo-purple.png"
            ></img>
          </div>
        )}
        <div className="error-state__content">
          <span className="material-icons error-state__icon">
            error_outline
          </span>
          <p className="error-state__message">{description}</p>
        </div>
      </div>
    );
  },
);

export default ErrorState;
